import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAdmin } from '../attendedUtils';

const S = {
  page: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '40px 24px',
    color: '#e0e0e0',
    fontFamily: 'sans-serif',
  },
  header: {
    marginBottom: '36px',
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#bb86fc',
    margin: '0 0 6px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#777',
    margin: 0,
  },
  section: {
    marginBottom: '32px',
  },
  sectionTitle: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#555',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '12px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: '12px',
  },
  actionCard: {
    backgroundColor: '#1e1e2e',
    border: '1px solid #333',
    borderRadius: '10px',
    padding: '20px',
    cursor: 'pointer',
    transition: 'border-color 0.15s, background-color 0.15s',
    textAlign: 'left',
  },
  actionIcon: {
    fontSize: '24px',
    marginBottom: '10px',
  },
  actionTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#e0e0e0',
    marginBottom: '4px',
  },
  actionDesc: {
    fontSize: '12px',
    color: '#777',
    lineHeight: '1.4',
  },
};

const ACTIONS = [
  {
    id: 'picklists',
    icon: '🗂️',
    title: 'Add/Update Picklist Values',
    desc: 'Manage dropdown options for artist types, venue types, attendance estimates, and more.',
    path: '/admin/picklists',
  },
  {
    id: 'bulk-edit-artists',
    icon: '🎸',
    title: 'Bulk Edit Artists',
    desc: 'Update genre, type, and other fields across multiple artist records at once.',
    path: '/admin/bulk-edit-artists',
  },
  {
    id: 'sharc-ids',
    icon: '✔️',
    title: 'Manage SHARC IDs',
    desc: 'Set or clear the Verified SHARC ID on Artist, Event, Member, and Venue records.',
    path: '/admin/sharc-ids',
  },
  {
    id: 'change-log',
    icon: '📋',
    title: 'View Change Log',
    desc: 'Full audit trail of all field-level edits across every entity.',
    path: '/admin/change-log',
  },
  {
    id: 'deletion-queue',
    icon: '🗑️',
    title: 'Deletion Queue',
    desc: 'Review, permanently delete, or reverse pending deletion requests across all entity types.',
    path: '/admin/deletion-queue',
    adminOnly: true,
  },
];

export default function AdminPortal() {
  const navigate = useNavigate();
  const [userIsAdmin, setUserIsAdmin] = useState(false);

  useEffect(() => {
    isAdmin().then(setUserIsAdmin).catch(() => setUserIsAdmin(false));
  }, []);

  const visibleActions = ACTIONS.filter(action => !action.adminOnly || userIsAdmin);

  return (
    <div style={S.page}>
      <div style={S.header}>
        <h1 style={S.title}>Admin Portal</h1>
        <p style={S.subtitle}>Site administration tools for SHARC.</p>
      </div>

      <div style={S.section}>
        <div style={S.sectionTitle}>Data Management</div>
        <div style={S.grid}>
          {visibleActions.map(action => (
            <ActionCard
              key={action.id}
              action={action}
              onClick={() => navigate(action.path)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

function ActionCard({ action, onClick }) {
  const [hovered, setHovered] = React.useState(false);
  return (
    <div
      style={{
        ...S.actionCard,
        borderColor: hovered ? '#bb86fc' : '#333',
        backgroundColor: hovered ? '#2a1f3d' : '#1e1e2e',
      }}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={S.actionIcon}>{action.icon}</div>
      <div style={S.actionTitle}>{action.title}</div>
      <div style={S.actionDesc}>{action.desc}</div>
    </div>
  );
}
